export const CATEGORY_LABELS: Record<string, string> = {
  dicas:          "Dicas",
  tendencias:     "Tendências",
  noticias:       "Notícias",
  armacoes:       "Armações",
  lentes:         "Lentes",
  "saude-visual": "Saúde Visual",
  negocios:       "Negócios",
  produtos:       "Produtos",
  outros:         "Outros",
};

export function categoryLabel(slug: string): string {
  return CATEGORY_LABELS[slug] ?? slug;
}
